module.exports = __webpack_public_path__ + "img/koniec@mob.02cfae19.png";